export { ImageGroupRender } from './ImageGroupRender';
